import { message, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom';
import { dateRangePeriods, momentToUnixRange } from '../../Utils/date';
import { useDispatch } from 'react-redux';
import { balanceFetchListReplenishments } from '../../Reducers/balance';
import Filters from '../Balance/Filters';
import ReplenishmentTable from './ReplenishmentTable';

const thisWeek = dateRangePeriods()['This Week'];

const Replenishments = () => {

  const isManager = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const [filters, setFilters] = useState({
    dates: momentToUnixRange([thisWeek[0], thisWeek[1]]),
  });

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(balanceFetchListReplenishments(filters.dates)).catch((error) => {
      if (error.includes('403 Forbidden')) {
        return message.error('Status 403 Forbidden');
      }
      message.error(error.message || error);
    });
  }, []);

  useEffect(() => {
    if (filters.dates.includes(null)) {
      message.info('Please select the dates!');
      return;
    }
  }, [filters]);

  const handleDeleteReplenishment = () => {
  }

  const handleFetch = () => {
    dispatch(balanceFetchListReplenishments(filters.dates)).catch((error) => {
      if (error.includes('403 Forbidden')) {
        return message.error('Status 403 Forbidden');
      }
      message.error(error.message || error);
    });
  }


  return (
    <div>
      <Typography.Title>Transactions</Typography.Title>

      <Filters
              className="mb"
              defaultFilters={filters}
              setFilters={setFilters}
            />


        <ReplenishmentTable
              isManager={isManager}
              handleFetch={handleFetch}
              // newInvoiceId={newInvoiceId}
            />

    </div>
  )
}

export default Replenishments
